var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _rect, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobotAdaptiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 101,
    viewBox: "0 0 102 101",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.0428 27.2983C97.3419 19.2921 91.253 12.9969 88.1342 10.1409C78.9908 3.66989 74.1367 2.97353 68.0142 2.09518L67.8938 2.07791C58.3588 0.709666 37.3188 0.835718 28.5861 3.42017C17.6703 6.65073 11.4326 13.1119 7.74676 19.8539C4.06089 26.596 -0.192032 37.2709 2.50149 58.6207C4.6563 75.7005 13.701 81.937 21.3561 86.1507L33.9733 92.6119L49.1419 99.3539C56.2301 96.4979 73.1 89.2689 83.8741 83.2011C97.3417 75.6163 99.8934 61.9917 100.602 58.6207C102.108 51.4573 100.877 35.9301 99.0428 27.2983Z",
    fill: "url(#paint0_linear_1827_12491)",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9067 58.4609H99.9883L99.5645 60.6053L98.9994 63.0355L98.1519 65.6087L97.0218 68.3249C89.4501 68.4393 83.5548 68.2773 82.7543 67.896C81.2852 65.9518 81.6242 60.4147 81.9067 58.4609Z",
    stroke: "black",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6402 25.0037C78.1134 18.2262 86.8816 13.7398 90.2812 12.6573C81.0783 2.27685 69.5824 1.70445 58.328 1.14408L58.0839 1.13192C48.8782 0.673131 31.8157 1.25694 23.096 5.36793C12.6138 10.3099 6.80612 19.2054 4.11475 27.5361C1.42338 35.8667 0.856781 50.1278 1.98999 57.3289C3.33189 65.8562 5.8082 79.59 17.7133 83.0268C30.8868 86.8297 47.6017 85.5589 61.6252 82.3208C74.0297 79.4564 75.365 65.813 75.9317 60.0228L75.9319 60.0209C76.4985 54.2318 74.7987 33.4756 76.6402 25.0037Z",
    fill: "url(#paint1_linear_1827_12491)",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8373 49.4334C47.4114 53.2317 51.0156 57.1707 54.9363 57.1707C58.8569 57.1707 62.0352 52.5411 62.0352 49.4334C62.0352 46.3256 59.4796 42.1181 54.9363 42.1181C49.967 41.8367 47.8373 46.3256 47.8373 49.4334Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5288 49.4334C10.1028 53.2317 13.707 57.1707 17.6277 57.1707C21.5483 57.1707 24.7266 52.5411 24.7266 49.4334C24.7266 46.3256 22.171 42.1181 17.6277 42.1181C12.6584 41.8367 10.5288 46.3256 10.5288 49.4334Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.69548,
    cy: 2.36739,
    rx: 2.69548,
    ry: 2.36739,
    transform: "matrix(-1 0 0 1 57.2852 44.9062)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.69548,
    cy: 2.36739,
    rx: 2.69548,
    ry: 2.36739,
    transform: "matrix(-1 0 0 1 20.1953 44.9062)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.539096,
    cy: 0.538043,
    rx: 0.539096,
    ry: 0.538043,
    transform: "matrix(-1 0 0 1 21.4922 48.9922)",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.539096,
    cy: 0.538043,
    rx: 0.539096,
    ry: 0.538043,
    transform: "matrix(-1 0 0 1 58.582 48.9922)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.3696,
    height: 3.44348,
    rx: 1.72174,
    transform: "matrix(-1 0 0 1 41.9805 67.0703)",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8395 63.4266C64.12 58.6441 72.1517 58.1602 75.8281 58.5872C75.4039 66.8427 74.8383 70.9705 71.1619 76.0946C68.2409 80.1657 63.5261 82.2151 58.5771 82.7844V71.1128C58.5771 66.4157 60.1325 64.6128 60.8395 63.4266Z",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.278 26.3478C82.8231 24.0678 88.3697 20.9878 91.3807 19.5078L94.5898 28.1478C92.4029 28.4358 84.7248 32.5878 81.0403 39.3078L79.4952 31.2678C79.5744 30.7478 79.8605 28.4395 81.278 26.3478Z",
    fill: "#CAA2FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2805 80.6651L96.3203 69.0078L95.5277 70.4696L94.6218 72.0438C93.4167 73.8333 91.5736 76.5934 88.5617 79.1279C86.1515 81.156 84.2155 82.4765 79.3952 84.7433L73.9001 87.6737L58.9992 88.0618L42.4212 88.5732L27.8141 89.023L18.0772 84.0988L17.3966 83.5177C28.4795 86.5203 50.0816 85.5564 61.7709 83.409L78.2805 80.6651Z",
    fill: "#7057F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.99 89.8828H58.1036L51.6797 96.5545L66.99 89.8828Z",
    fill: "#383740"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7408 60.6172H97.3984L96.3202 63.9459L84.1002 64.0607C83.5251 63.3261 83.5012 61.4589 83.7408 60.6172Z",
    fill: "#826CF7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0479 90.3164H55.6608L48.875 97.6338L65.0479 90.3164Z",
    fill: "#634AE4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7578 88.1641L27.533 89.6254L32.4817 92.2558L34.1784 93.1327L35.3095 93.7172L49.1659 100.001L55.8113 97.2244L62.4567 94.1556L74.7578 88.1641Z",
    fill: "#7057F0",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9894 90.3164H56.2503L49.7383 97.6338L66.9894 90.3164Z",
    fill: "#644AE7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1827_12491",
    x1: 90.9267,
    y1: 14.2355,
    x2: 63.1381,
    y2: 99.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B589FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491707,
    stopColor: "#AF86FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738033,
    stopColor: "#866FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806CF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1827_12491",
    x1: 45.8597,
    y1: 0.999999,
    x2: 83.5698,
    y2: 121.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453744,
    stopColor: "#F3EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCA6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotAdaptiveIcon);
export default __webpack_public_path__ + "static/media/RobotAdaptiveIcon.55456cf9a3434ef23ef5bee67d5046cd.svg";
export { ForwardRef as ReactComponent };